import { NUANCE_STATIC_ASSETS_URL } from "@/constants";

export const SDK_SCRIPT_SRC =
  `${NUANCE_STATIC_ASSETS_URL}/nuan_websdk_bootstrap.min.0.0.4.js` as const;
export const SDK_LINK_SRC =
  `${NUANCE_STATIC_ASSETS_URL}/nuance-chat.min.0.0.4.css` as const;
export const C2C_SCRIPT_SRC =
  `${NUANCE_STATIC_ASSETS_URL}/nuan-c2c.0.0.4.js` as const;
export const C2C_LINK_SRC =
  `${NUANCE_STATIC_ASSETS_URL}/nuance-c2c-button.0.0.4.css` as const;

export const ORIGINS: Readonly<string[]> = [
  "https://asos.digital.nuance.com",
  "https://asos-preprod.lle.digital.nuance.com",
  "https://asos-stage.lle.digital.nuance.com",
];
